// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.v-input--selection-controls[data-v-38d3ff56]{\n  margin-top:0\n}\n.v-input--selection-controls[data-v-38d3ff56]  .v-input__slot{\n  margin-bottom:0!important\n}\n.v-input--selection-controls[data-v-38d3ff56]  .v-messages{\n  display:none\n}\n.ce-systimecmstable .tablegrid th[data-v-38d3ff56]{\n  vertical-align:top\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
